 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"patch-notes-ca":"patch-notes-ca","patch-notes-de":"patch-notes-de","patch-notes-en":"patch-notes-en","patch-notes-fr":"patch-notes-fr"}[chunkId]||chunkId) + ".v.7.6.0.1793352931796.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-4462c5fc":1,"chunk-0a42c511":1,"chunk-0b9d21e2":1,"chunk-16b7ed64":1,"chunk-1eeac770":1,"chunk-25e94f94":1,"chunk-2bee396a":1,"chunk-b74b37fa":1,"chunk-2b8c2b7a":1,"chunk-250edeba":1,"chunk-4cb3acda":1,"chunk-7ae71732":1,"chunk-33810af2":1,"chunk-3464d699":1,"chunk-3beb8d06":1,"chunk-3d515cca":1,"chunk-3d8137f5":1,"chunk-41f5de02":1,"chunk-488a0d14":1,"chunk-4c38a1a9":1,"chunk-13053ce3":1,"chunk-238e25a1":1,"chunk-405bf51e":1,"chunk-796702dc":1,"chunk-83af610e":1,"chunk-de3b12f2":1,"chunk-4f1f6724":1,"chunk-4f74bac8":1,"chunk-50189c26":1,"chunk-54b00c26":1,"chunk-566bed53":1,"chunk-5d4c6c54":1,"chunk-6027fb04":1,"chunk-6883976a":1,"chunk-1af42b00":1,"chunk-74b8069d":1,"chunk-35f895f7":1,"chunk-27b87cde":1,"chunk-53cdcdf2":1,"chunk-29863218":1,"chunk-55902796":1,"chunk-748938ac":1,"chunk-3d0ad6aa":1,"chunk-7ac734aa":1,"chunk-7cdea4a2":1,"chunk-454a0c56":1,"chunk-567119d7":1,"chunk-924847e2":1,"chunk-9e018b14":1,"chunk-3d91d2b3":1,"chunk-7eb729af":1,"chunk-b38d87a0":1,"chunk-b6b5fa52":1,"chunk-cddcd92c":1,"chunk-d1551492":1,"chunk-d8ce5a38":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"patch-notes-ca":"patch-notes-ca","patch-notes-de":"patch-notes-de","patch-notes-en":"patch-notes-en","patch-notes-fr":"patch-notes-fr"}[chunkId]||chunkId) + "." + {"chunk-047ad542":"31d6cfe0","chunk-098b0cae":"31d6cfe0","chunk-4462c5fc":"1825cabb","chunk-0a42c511":"cfdb75c5","chunk-0b9d21e2":"5c7b06b6","chunk-16b7ed64":"5f8bc21c","chunk-17bf8d04":"31d6cfe0","chunk-1eeac770":"021bce2e","chunk-25e94f94":"f1fd5b7f","chunk-2bee396a":"67907fe9","chunk-b74b37fa":"be64f857","chunk-2b8c2b7a":"f07a972e","chunk-1081ccc1":"31d6cfe0","chunk-1949e971":"31d6cfe0","chunk-250edeba":"0d786869","chunk-4cb3acda":"33fd2396","chunk-7ae71732":"4683782e","chunk-2d0afa4b":"31d6cfe0","chunk-2d0b8a33":"31d6cfe0","chunk-2d0baa6b":"31d6cfe0","chunk-2d221bba":"31d6cfe0","chunk-2d237c74":"31d6cfe0","chunk-2e8971e9":"31d6cfe0","chunk-33810af2":"3ffd2f19","chunk-3464d699":"1514e59e","chunk-3beb8d06":"09ecced3","chunk-3d515cca":"1112fec7","chunk-3d8137f5":"f00d1a20","chunk-41f5de02":"ec33e3aa","chunk-488a0d14":"149d8a6d","chunk-4c38a1a9":"4c1b2dc5","chunk-13053ce3":"41046d1a","chunk-238e25a1":"2d9851bb","chunk-405bf51e":"4511aa5c","chunk-796702dc":"ac849df2","chunk-83af610e":"6bfac08d","chunk-de3b12f2":"bd7191be","chunk-4f1f6724":"2dfedec8","chunk-4f74bac8":"1fe03517","chunk-50189c26":"5afd38da","chunk-54b00c26":"860d6343","chunk-566bed53":"03ce700d","chunk-5d4c6c54":"7c71976e","chunk-6027fb04":"7ef620e0","chunk-63c527d9":"31d6cfe0","chunk-6883976a":"0a40e5ad","chunk-1af42b00":"a6511404","chunk-7110de74":"31d6cfe0","chunk-74b8069d":"4ccf3fd7","chunk-35f895f7":"dd79e655","chunk-158de85a":"31d6cfe0","chunk-171b28b4":"31d6cfe0","chunk-47db5b0a":"31d6cfe0","chunk-492e3951":"31d6cfe0","chunk-526c4a36":"31d6cfe0","chunk-5c42e83d":"31d6cfe0","chunk-6745bcfe":"31d6cfe0","chunk-8af169ce":"31d6cfe0","chunk-a4d835b2":"31d6cfe0","chunk-d9667660":"31d6cfe0","chunk-e819a30e":"31d6cfe0","chunk-1d4bbba2":"31d6cfe0","chunk-1dd8f333":"31d6cfe0","chunk-27b87cde":"ca673d2a","chunk-717a9f90":"31d6cfe0","chunk-746a7694":"31d6cfe0","chunk-389d2cb4":"31d6cfe0","chunk-6f67c034":"31d6cfe0","chunk-d2db360a":"31d6cfe0","chunk-38b5baae":"31d6cfe0","chunk-38c2c4f6":"31d6cfe0","chunk-39f0b3df":"31d6cfe0","chunk-47d3a0b1":"31d6cfe0","chunk-4b0e9559":"31d6cfe0","chunk-564a55b8":"31d6cfe0","chunk-4eca8be1":"31d6cfe0","chunk-53cdcdf2":"9d2805a9","chunk-29863218":"dca8072a","chunk-55902796":"2de7b2a1","chunk-3b705c74":"31d6cfe0","chunk-56d95d5a":"31d6cfe0","chunk-59a4c819":"31d6cfe0","chunk-59d1be41":"31d6cfe0","chunk-08066384":"31d6cfe0","chunk-0a2c3cb0":"31d6cfe0","chunk-0b79b891":"31d6cfe0","chunk-0da7c146":"31d6cfe0","chunk-115124f6":"31d6cfe0","chunk-13909e27":"31d6cfe0","chunk-2632a1aa":"31d6cfe0","chunk-2bd8d0a1":"31d6cfe0","chunk-2d2378a9":"31d6cfe0","chunk-37a9b8e2":"31d6cfe0","chunk-397313b4":"31d6cfe0","chunk-3ed5240c":"31d6cfe0","chunk-48a4cca1":"31d6cfe0","chunk-4b16913e":"31d6cfe0","chunk-4ce3aa9d":"31d6cfe0","chunk-4f7e08ce":"31d6cfe0","chunk-56e570ef":"31d6cfe0","chunk-5a829e20":"31d6cfe0","chunk-64605a26":"31d6cfe0","chunk-66728420":"31d6cfe0","chunk-6c44c98a":"31d6cfe0","chunk-713a9272":"31d6cfe0","chunk-7642c36b":"31d6cfe0","chunk-91c00810":"31d6cfe0","chunk-9be19df4":"31d6cfe0","chunk-c26412ce":"31d6cfe0","chunk-d0bb1644":"31d6cfe0","chunk-e5c9e832":"31d6cfe0","chunk-fe9247c8":"31d6cfe0","chunk-6a952dc3":"31d6cfe0","chunk-6b99cde1":"31d6cfe0","chunk-6caa8765":"31d6cfe0","chunk-6e2ba6a6":"31d6cfe0","chunk-6f647aaf":"31d6cfe0","chunk-6fa4d3ca":"31d6cfe0","chunk-7224b0e7":"31d6cfe0","chunk-748938ac":"a512a320","chunk-77ceb5dd":"31d6cfe0","chunk-791e3954":"31d6cfe0","chunk-9b6908dc":"31d6cfe0","chunk-b2655ed6":"31d6cfe0","chunk-b6da832e":"31d6cfe0","chunk-c3bfc710":"31d6cfe0","chunk-c9d77a1a":"31d6cfe0","chunk-cc665c12":"31d6cfe0","chunk-f5615170":"31d6cfe0","chunk-3d0ad6aa":"d41773e4","chunk-281cca88":"31d6cfe0","chunk-2df4511e":"31d6cfe0","chunk-afc207ec":"31d6cfe0","chunk-7ac734aa":"6c6cb5d8","chunk-7cdea4a2":"3d792aa1","chunk-454a0c56":"49454b09","chunk-567119d7":"54bc5147","chunk-924847e2":"31b4e4d0","chunk-9e018b14":"0386daee","chunk-ad505b78":"31d6cfe0","chunk-ae5d7f06":"31d6cfe0","chunk-3d91d2b3":"2d29d881","chunk-7eb729af":"3c3cf52a","chunk-b38d87a0":"75d39c12","chunk-b6b5fa52":"8a84604b","chunk-c60278ce":"31d6cfe0","chunk-cddcd92c":"c49c3f7c","chunk-cf9b4218":"31d6cfe0","chunk-d1551492":"42ea5b23","chunk-d8ce5a38":"8bb42433","chunk-ebbd4d8e":"31d6cfe0","patch-notes-ca":"31d6cfe0","patch-notes-de":"31d6cfe0","patch-notes-en":"31d6cfe0","patch-notes-fr":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
